import React from 'react';
import './WeekTabs.css';

function WeekTabs({ selectedDay, handleWeekTabClick }) {
  const days = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];

  return (
    <div className="week-tabs-container">
      <div className="week-tabs-inner">
        {days.map((day) => (
          <button
            key={day}
            onClick={() => handleWeekTabClick(day)}
            className={`week-tab-button ${selectedDay === day ? 'active' : ''}`}
          >
            {day}
          </button>
        ))}
      </div>
    </div>
  );
}

export default WeekTabs;
